module.exports = __webpack_public_path__ + "static/path_of_the_beast-3e49f5d8c54f47340413bbb6b2fc111b.png";